var render, staticRenderFns
import script from "./BrandCompanySettingsSubscriptionPage.vue?vue&type=script&lang=js"
export * from "./BrandCompanySettingsSubscriptionPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports